import { useSuspenseUserGroups } from '../../../api/lending/lapiHooks.suspense';
import { useQueryParam } from '../../../hooks/useQueryParam';

export const useSuspenseIsImpersonating = () => {
  const stateKeyParam = useQueryParam('state_key');
  const { isStaff } = useSuspenseUserGroups();

  // remember that AccessUsers have state_key params, but are not impersonating
  if (isStaff && stateKeyParam)
    return { isImpersonating: true, impersonationStateKey: stateKeyParam };

  return {
    isImpersonating: false,
    impersonationStateKey: undefined,
  };
};
